import CryptoJS from "react-native-crypto-js";
import { WEB_AUTH_URL, WEB_CORE_URL } from "../configurations/paths.config";
import { PARAM_NAME_PW } from "../configurations/staticTypes.config";
import { PARAM_NAME_TOKEN } from "../configurations/strings.config";
import axios from "axios";
import { authHeaderJson, authHeaderJsonAuth } from "../services/auth-header.service";


const encryptBase64 = (msg, pass) => {
    let ciphertext = CryptoJS.AES.encrypt(msg, pass).toString();

    return ciphertext;
}

const decryptBase64 = (transitmessage, pass) => {
    let bytes  = CryptoJS.AES.decrypt(transitmessage, pass);
    let originalText = bytes.toString(CryptoJS.enc.Utf8);

    return originalText
}
const getValidPath = (path) => {
    if (path.indexOf("http://") === -1 || path.indexOf("https://") === -1) {
      return "https://" + path
    }
    else {
      return path.replace("http://", "https://")
    }
}
const calculateTimeLeft = (startDate, endDate) => {
    let difference = +endDate - +startDate;
  
    let timeLeft = {};
  
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }
  
    return timeLeft;
}

const stringFormat = (theString, argumentArray) => {
    const regex = /%s/;
    const _r=function(p,c){return p.replace(regex,c);}
    return argumentArray.reduce(_r, theString);
}

const isValidFormControlUrl = (value) =>{	
    return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
}

const getAuth = () => {
    let name = PARAM_NAME_TOKEN;
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for(const element of ca) {
        let c = element;
        while (c.startsWith(' ')) {
            c = c.substring(1);
        }
        if (c.startsWith(name+"=")) {
            return c.substring((name+"=").length, c.length);
        }
        if (c.startsWith(name+"2=")) {
            return c.substring((name+"2=").length, c.length)
        }
    }

    return null;
}

const getAuthUCookie = async () => {
    let response = await axios({ method: "GET", url: `${WEB_AUTH_URL}/get-ucookie`, headers: authHeaderJson() });
    return JSON.stringify(response.data)
}

const getExpAuth = async () => {
    return await axios({ method: "GET", url: `${WEB_AUTH_URL}/get-tk`, headers: authHeaderJson() })
}

const setAuth = async (value) => {
    let cvalue = JSON.parse(value);
    const headers = authHeaderJsonAuth(cvalue)
	delete cvalue.tk;
	delete cvalue.rtk;

    await axios.post('/set-tk', cvalue, { headers: headers });
}

const setAuthEdit = async (value) => {
    await axios.post('/set-tke', value, { headers: { "Content-Type": "application/json" } });
}

const setAuthEx = async (value) => {
    await axios.post('/set-tkk', JSON.parse(value));
}

const encodeTokenForTransport = (value) => {
    if (isNullUndefinedOrEmpty(value)) {
        return null;
    }

    return String(value).replace(/-/g, '_SG3_');
};

const removeAuth = async () => {
    await axios({ method: "GET", url: `${WEB_AUTH_URL}/remove-cookies`, headers: { "Content-Type": "application/json" } });
}

const removeAuthExt = async () => {
    await axios({ method: "GET", url: `${WEB_AUTH_URL}/remove-cookies-ext`, headers: { "Content-Type": "application/json" } });
}

const isNullOrUndefined = (elementProperty) => {
    return elementProperty === null || elementProperty === undefined;
};

const isNullUndefinedOrEmpty = (elementProperty) => {
    return elementProperty === null || elementProperty === undefined || elementProperty === "";
};

const onGoToSG3PlusClick = async () => {
    //const respose = await getExpAuth();
    //let stringToBase64 = encryptBase64(respose.data.data, PARAM_NAME_PW);
    //const querySG3Url = `${WEB_CORE_URL}/login?stats=success&tk=${encodeURIComponent(stringToBase64)}`;
    const querySG3Url = `${WEB_CORE_URL}`;
    window.location.replace(`${querySG3Url}`);
}

const countBy = (arr, fn) =>
  arr.map(typeof fn === 'function' ? fn : val => val[fn]).reduce((acc, val, i) => {
    acc[val] = (acc[val] || 0) + 1;
    return acc;
}, {});

const unique = (value, index, self) => {
    return self.indexOf(value) === index
}

const fieldSorter = (fields) => {
    return function (a, b) {
        return fields
            .map(function (o) {
                let dir = 1;
                if (o[0] === '-') {
                   dir = -1;
                   o=o.substring(1);
                }
                if (a[o] > b[o]) return dir;
                if (a[o] < b[o]) return -(dir);
                return 0;
            })
            .reduce(function firstNonZeroValue (p,n) {
                return p || n;
            }, 0);
    };
}

const isValidDate = (dateString) => {
    const timestamp = Date.parse(dateString);

    return (isNaN(timestamp) === false)
}

const showMessage = (setter, show, type, message) => {
    setter({
        message: message,
        messageType: type,
        showMessage: show,
    })
}

export {
    encryptBase64,
    decryptBase64,
    getValidPath,
    calculateTimeLeft,
    stringFormat,
    isValidFormControlUrl,
    getAuth,
    getAuthUCookie,
    getExpAuth,
    setAuth,
    setAuthEdit,
    setAuthEx,
    encodeTokenForTransport,
    removeAuth,
    removeAuthExt,
    onGoToSG3PlusClick,
    countBy,
    unique,
    fieldSorter,
    isValidDate,
    showMessage,
    isNullUndefinedOrEmpty,
    isNullOrUndefined
}